import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Card from "react-bootstrap/Card";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMusic } from "@fortawesome/free-solid-svg-icons";
import axios from "react-axios";
import { getRecentPlaylists } from "~/api/getCustomPlaylists";

const RecentPlaylists = ({ limit = 10 }) => {
  const [loading, setLoading] = useState(true);
  const [playlists, setPlaylists] = useState([]);
  const load = async () => {
    const resp = await getRecentPlaylists(axios, limit);
    setPlaylists(resp.data.playlists);
    setLoading(false);
  };
  useEffect(() => {
    load();
  }, []);

  return (
    (!loading && playlists.length !== 0 && (
      <div className="mb-feature-box">
        <div className="sideNavSection">
          <h3>
            <FontAwesomeIcon icon={faMusic} style={{ fontSize: 24, marginRight: 8 }} />
            Recent Playlists
          </h3>
          <div className="playlistSideNav">
            {playlists.map((p) => (
              <Link to={`/playlist/${p.id}`}>
                <Card body className={`relatedCard text-left${Number(p.collaborative) === 1 ? " is-collaborative" : ""}`}>
                  <span className="title">
                    {p.name}
                    {Number(p.collaborative) === 1 && <span className="playlistCollabBadge">Collaborative</span>}
                  </span>
                  <span className="author">Created by: {p.chimName ? `${p.chimName} Chimney` : p.userName}</span>
                </Card>
              </Link>
            ))}
          </div>
          <div>
            <Link to={"/playlists/recent"}>Recent Playlists</Link>
          </div>
        </div>
      </div>
    )) ||
    null
  );
};

export default RecentPlaylists;
